<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';

export default {
  components: {
    VueSlider,
  },
  props: {
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    marks: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <VueSlider :value="value" @change="$emit('set-value', $event)" :marks="marks" />
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.vue-slider {
  height: 2.7rem !important;
  &.vue-slider-ltr {
    height: 2.7rem !important;
  }
  ::v-deep .vue-slider-dot {
    height: 3rem !important;
    width: 3rem !important;
    .vue-slider-dot-handle {
      &::before {
        display: none;
      }
    }
  }
  &:hover {
    cursor: pointer;
    ::v-deep {
      .vue-slider-process {
        background-color: $color-action;
      }
    }
  }
  ::v-deep .vue-slider-rail {
    background-color: white;
    .vue-slider-process {
      &:hover {
        background-color: $color-action !important;
      }
    }
    &:hover {
      .vue-slider-process {
        background-color: $color-action;
      }
    }

    .vue-slider-marks {
      .vue-slider-mark {
        width: 3px !important;
        &:first-child {
          display: none;
        }
        &:last-child {
          display: none;
        }
      }
      .vue-slider-mark-step {
        background-color: #353535;
        border-radius: unset;
        box-shadow: unset;
      }
      .vue-slider-mark-label {
        display: none;
      }
    }
  }
}
</style>
